import Vue from "vue";

Vue.component("publication-media-management", {
    props: ["publicationMedias", "modificationModel"],
    data() {
        return {
            loading: false,
            revisionModel: this.modificationModel,
            contextId: '0|0|0'
        };
    },
    methods: {
        edit(publicationMedia) {
            const self = this;
            console.log(publicationMedia);
            self.$refs.fieldEditor.initialize(publicationMedia.id);
        }
    },
    watch: {
        contextId: function (context) {
            console.log(context);
            const self = this;

            if (context != null && context != undefined && context != '0|0|0') {
                const splitted = context.split('|');
                if (splitted != null && splitted[0] != null && splitted[1] != null) {
                    if (splitted[1] != '0') {
                        self.revisionModel.updatedCount += 1;
                        self.$emit('update:modificationModel', self.revisionModel);                        
                    }
                }
            }
        }
    },
    template: `
		<div class="annex-entities">
			<template v-if="loading"><loading></loading></template>
			<template v-else>
				<div v-for="publicationMedia in publicationMedias" :key="publicationMedia.id" :id="publicationMedia.id">
                    <b-tooltip class="custom"
                                type="is-success"
                                :label="publicationMedia.tooltip"
                                position="is-right"
                                multilined>
                                <div :style="{'margin-left': publicationMedia.indentation, 'cursor': 'pointer'}" v-html="publicationMedia.text" @click="edit(publicationMedia)"></div>
                    </b-tooltip>                    
				</div>
			</template>
            <publication-media-basic-info-editor ref="fieldEditor" :useModal="true" :contextId.sync="contextId"></publication-media-basic-info-editor>
		</div>
	`
});